// class Eventbus {
//     constructor() {
//         this.events = {};
//     }

//     on(event, callback) {
//         const callbacks = this.events[event] || [];
//         if (!callbacks.find((it) => it === callback)) {
//             callbacks.push(callback);
//             this.events[event] = callbacks;
//         }
//         return this;
//     }

//     off(event, callback) {
//         const callbacks = this.events[event];
//         this.events[event] =
//             callbacks && callbacks.filter((it) => it !== callback);
//         return this;
//     }

//     emit(...args) {
//         const event = args[0];
//         const params = [].slice.call(args, 1);
//         const callbacks = this.events[event];
//         callbacks && callbacks.forEach((fn) => fn.apply(this, params));
//         return this;
//     }

//     once(event, callback) {
//         const wrapFunc = (...args) => {
//             callback.apply(this, args);
//             this.off(event, wrapFunc);
//         };
//         this.on(event, wrapFunc);
//         return this;
//     }
// }

// export const eventbus = new Eventbus();

export const EVT_ADD_BOX_SUCCESS = "EVT_ADD_BOX_SUCCESS";

export const EVT_START_CIRCLE = "EVT_START_CIRCLE";

export const EVT_STOP_CIRCLE = "EVT_STOP_CIRCLE";

export const EVT_SHOW_NO_FREE_BOX_DIALOG = "EVT_SHOW_NO_FREE_BOX_DIALOG";

export const EVT_NO_FREE_BOX_DIALOG_CLOSED = "EVT_NO_FREE_BOX_DIALOG_CLOSED";
export const EVT_PACKAGE_ERROR_TIP = "EVT_PACKAGE_ERROR_TIP";

// 真实库存小于等于1的事件
export const EVT_NO_BOX = "EVT_NO_BOX";

// 关闭了MyFit功能中点击问号出现的dialog的事件
export const EVT_CLOSE_QUESTION_DIALOG = "EVT_CLOSE_QUESTION_DIALOG";
